// D105.10: a pair like "6-12oz" (or, D157.12, a grade like "21/25 ct") may be a pack or a size range. The
// server flags the line amber and stores `unitMismatchReason: 'pack_ambiguous'`; this is the one place the grid reads it.
import type { QuotationItemDto } from '../../lib/quotationApi';

export const PACK_AMBIGUOUS_TIP =
  'The name holds a pair like "6-12oz" or "21/25 ct" that may be a pack or a size range, so no pack was read from it. Check which the vessel means. Re-pricing does not change this.';

/** Flagged only for the pair: priced in the unit asked, with the server's stored fact. */
export const isPackAmbiguousLine = (item: QuotationItemDto): boolean => !!item.unitMismatch && item.unitMismatchReason === 'pack_ambiguous';
